import { orejime } from '../../scripts/orejime';

const videoJsClass = 'js-video';
const videoButtonJsClass = videoJsClass + '-button';

const videoButtonElements = document.querySelectorAll('.' + videoButtonJsClass) as NodeListOf<HTMLElement>;

if (videoButtonElements) {
    videoButtonElements.forEach((videoButtonElement) => {
        videoButtonElement.addEventListener('click', () => {
            orejime.show();
        });
    });
}